export default __webpack_public_path__ + "/dist/images/search-recipe-icon.svg";